import { render, staticRenderFns } from "./DateTimeComponent.vue?vue&type=template&id=bba3a45c&scoped=true&"
import script from "./DateTimeComponent.vue?vue&type=script&lang=js&"
export * from "./DateTimeComponent.vue?vue&type=script&lang=js&"
import style0 from "./DateTimeComponent.vue?vue&type=style&index=0&id=bba3a45c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba3a45c",
  null
  
)

export default component.exports